export const ZgodovinaTock = {
  methods: {
    GetZgodovinaTock (prenosniParam) {
      if (prenosniParam.prenesenIzbranId !== '') {
        let param = ['idStranka=' + prenosniParam.prenesenIzbranId]
        this.clientAgent.postWsRequest(this,
          '/klub/pridobiZgodovinoTock?',
          param,
          prenosniParam,
          'SetZgodovinaTock',
          'ErrZgodovinaTock')
      }
    },
    SetZgodovinaTock (podatki, prenosniParam) {
      let podatkiZgodovinaTockKlub = podatki.data
      let vmesnik = prenosniParam.vmesnik
      vmesnik.PridobiPodatkeZgodovineTockKlub(prenosniParam, podatkiZgodovinaTockKlub)
    },
    ErrZgodovinaTock (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/Klub/ZgodovinaTock.js